import { useState } from 'react';
import { Box, Card, CardContent, Chip, Stack, Typography } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { batteryModelsApi, type BatteryModelSummary } from '@/api/modules/batteryModels';
import { PaginatedList } from '@/components/data/PaginatedList';

export function BatteryModelListPage() {
  const [page, setPage] = useState(0);
  const query = useQuery({
    queryKey: ['battery-models', 'summaries', page],
    queryFn: () => batteryModelsApi.summaries(page, 20)
  });

  return (
    <Box>
      <Typography variant="h1" gutterBottom>
        Battery models
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Lightweight summary view. Tap a row to load the full model detail.
      </Typography>
      <PaginatedList<BatteryModelSummary>
        page={query.data}
        isLoading={query.isLoading}
        error={query.error}
        onPageChange={setPage}
        renderItem={(model) => (
          <Card variant="outlined">
            <CardContent>
              <Stack
                direction={{ xs: 'column', sm: 'row' }}
                spacing={1}
                alignItems={{ sm: 'center' }}
                justifyContent="space-between"
              >
                <Box>
                  <Typography variant="h3">{model.name}</Typography>
                  <Typography variant="body2" color="text.secondary">
                    {model.code}
                  </Typography>
                </Box>
                <Chip
                  size="small"
                  label={model.status}
                  color={model.status === 'ACTIVE' ? 'success' : 'default'}
                />
              </Stack>
            </CardContent>
          </Card>
        )}
        emptyMessage="No battery models registered yet."
      />
    </Box>
  );
}
